module.exports = __webpack_public_path__ + "static/vision-9b998ff2e1a499e80323b58d4cd1ebc6.svg";